(function () {
  'use strict';

  var HIDE_MS = 210;

  function softShow(el) {
    if (!el) return;
    el.classList.remove('is-closing');
    delete el.dataset.closing;
    el.hidden = false;
  }

  function softHide(el, instant) {
    if (!el || el.hidden || el.dataset.closing === '1') return;
    if (instant) { el.hidden = true; return; }
    el.dataset.closing = '1';
    el.classList.add('is-closing');
    setTimeout(function () {
      el.hidden = true;
      el.classList.remove('is-closing');
      delete el.dataset.closing;
    }, HIDE_MS);
  }

  function isShown(el) {
    return el && !el.hidden && el.dataset.closing !== '1';
  }

  function getBackdrop() {
    var backdrop = document.querySelector('[data-bundle-backdrop]');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'bundle-backdrop';
      backdrop.setAttribute('data-bundle-backdrop', '');
      backdrop.hidden = true;
      document.body.appendChild(backdrop);
    }
    return backdrop;
  }

  function relocateInventoryBlock(root) {
    var header = root.querySelector('.bundle-items__header');
    if (!header) return;
    var inventory = document.querySelector('.product__block.product__block--inventory');
    if (!inventory || header.contains(inventory)) return;
    header.insertBefore(inventory, header.firstChild);
  }

  // Finds the PDP price element in the title block
  function findPriceEl() {
    var selectors = [
      '.product-single [data-product-price]',
      '.product-single .product__price',
      '.product-single__price',
      '.product__block--title [data-product-price]',
      '.product__block--title .product__price',
      '.product-single .price__current',
      '.product-single .price'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && el.textContent.trim()) return el;
    }
    return null;
  }

  function initOne(root, configEl) {
    if (!root || !configEl || root.dataset.bundleInit === 'true') return;
    root.dataset.bundleInit = 'true';

    var config;
    try { config = JSON.parse(configEl.textContent); } catch (e) { return; }

    var section = root.closest('.product-single');
    if (section) section.classList.add('bundle-mode');

    relocateInventoryBlock(root);

    var fonts = window.monogram_font_faces || [{ title: 'Serif' }];
    var sizes = window.monogram_font_sizes || [{ title: '36PT' }];
    var foilsAll = window.monogram_colors || [
      { title: 'Silver', colour: '#c1c1c1' },
      { title: 'Gold', colour: '#caaa45' },
      { title: 'Blind (no colour)', colour: '' }
    ];

    var backdrop = getBackdrop();
    var atcBtn = root.querySelector('[data-bundle-atc]');
    var atcCompare = root.querySelector('[data-atc-compare]');
    var atcPrice = root.querySelector('[data-atc-price]');
    var errorsEl = root.querySelector('[data-bundle-errors]');
    var monoPanels = [];

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-item]')).map(function (el) {
      return {
        el: el,
        index: parseInt(el.dataset.index, 10),
        title: el.dataset.componentTitle || '',
        value: ((el.querySelector('[data-colour-label]') || {}).textContent || '').trim(),
        mono: null,
        monoFoil: null
      };
    });

    function money(cents) {
      var n = cents / 100;
      var sym = config.currencySymbol || '$';
      var opts = (Math.round(n * 100) % 100 === 0)
        ? { maximumFractionDigits: 0 }
        : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
      return sym + n.toLocaleString(undefined, opts);
    }

    function selectedOptionBtn(it) {
      var btns = it.el.querySelectorAll('[data-colour-option]');
      for (var i = 0; i < btns.length; i++) {
        if (btns[i].dataset.value === it.value) return btns[i];
      }
      return btns[0] || null;
    }

    function skuFor(it) {
      var btn = selectedOptionBtn(it);
      return ((btn && btn.dataset.sku) || '').trim().toUpperCase();
    }

    function componentTotal() {
      var sum = 0;
      items.forEach(function (it) {
        var btn = selectedOptionBtn(it);
        sum += parseInt((btn && btn.dataset.price) || '0', 10);
      });
      return sum;
    }

    function currentVariant() {
      var vals = items.map(function (it) { return it.value; });
      for (var i = 0; i < config.variants.length; i++) {
        var v = config.variants[i];
        var match = true;
        for (var j = 0; j < vals.length; j++) {
          if (v.options[j] !== vals[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    // The pre-bundle value. Uses compare_at_price when the merchant has set one,
    // otherwise falls back to the sum of the component prices — so bundles show a
    // saving without anyone having to fill in compare-at on every variant.
    function compareFor(variant) {
      if (!variant) return 0;
      var compareAt = parseInt(variant.compareAtPrice || 0, 10);
      if (compareAt > variant.price) return compareAt;

      var sum = componentTotal();
      return sum > variant.price ? sum : 0;
    }

    // Whichever reads cleanest: a whole percentage, otherwise the amount saved
    function savingLabel(compare, price) {
      var diff = compare - price;
      if (diff <= 0) return '';

      var pctExact = (diff * 100) / compare;
      if (Math.abs(pctExact - Math.round(pctExact)) < 0.001) {
        return Math.round(pctExact) + '% Off';
      }
      return money(diff) + ' Off';
    }

    function buildSaveBadge() {
      var badge = document.createElement('div');
      badge.className = 'product__badge__item product__badge__item--saving bundle-pdp-save';
      badge.setAttribute('data-bundle-pdp-save', '');
      badge.innerHTML =
        '<span>Save <span class="rotate-wrapper"><span class="rotatebadgecoll">' +
        '<span data-bundle-save-value></span> <span data-bundle-save-value></span>' +
        '</span></span></span>';
      return badge;
    }

    // Adds the struck-through pre-bundle price and the Save badge next to the
    // PDP title price. The theme cannot do this itself because a bundle's saving
    // comes from its components, not from compare_at_price.
    function updatePdpPrice(variant, compareBase) {
      var priceEl = findPriceEl();
      if (!priceEl) return;

      var holder = priceEl.parentElement || priceEl;
      var compare = holder.querySelector('[data-bundle-pdp-compare]');
      var badge = holder.querySelector('[data-bundle-pdp-save]');

      if (!compare) {
        compare = document.createElement('span');
        compare.className = 'bundle-pdp-compare';
        compare.setAttribute('data-bundle-pdp-compare', '');
        priceEl.insertAdjacentElement('afterend', compare);
      }

      if (!badge) {
        badge = buildSaveBadge();
        (compare.parentElement || holder).appendChild(badge);
      }

      // If the theme already renders its own sale price (compare_at_price is
      // set), stay out of the way so the saving is not shown twice.
      var themeShowsSale = variant && parseInt(variant.compareAtPrice || 0, 10) > variant.price;
      var saves = variant && compareBase > variant.price;

      if (!saves || themeShowsSale) {
        compare.hidden = true;
        badge.hidden = true;
        return;
      }

      compare.textContent = money(compareBase);
      compare.hidden = false;

      var label = savingLabel(compareBase, variant.price);
      if (label) {
        badge.querySelectorAll('[data-bundle-save-value]').forEach(function (span) {
          span.textContent = label;
        });
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }

    function committedMonoCount(exceptIt) {
      return items.filter(function (o) { return o !== exceptIt && o.mono && o.mono.letters; }).length;
    }

    function updateMonoTotals() {
      var v = currentVariant();
      items.forEach(function (it) {
        if (it.monoRefs && it.monoRefs.totalEl) {
          var total = (v ? v.price : 0) + (config.monoPrice || 0) * (1 + committedMonoCount(it));
          it.monoRefs.totalEl.textContent = money(total);
        }
      });
    }

    function closeAllDropdowns() {
      root.querySelectorAll('[data-colour-list]').forEach(function (list) { softHide(list); });
      root.querySelectorAll('[data-colour-toggle]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      monoPanels.forEach(function (p) {
        var fl = p.panel.querySelector('[data-mono-colour-list]');
        if (fl) softHide(fl, true);
        softHide(p.panel);
        p.toggle.setAttribute('aria-expanded', 'false');
      });
      softHide(backdrop);
    }

    function positionMonoPanel(panel) {
      var gallery = document.querySelector('.product-single__gallery') ||
        document.querySelector('.product-single .product__images') ||
        document.querySelector('.product-single .product__slideshow');
      if (gallery) {
        var rect = gallery.getBoundingClientRect();
        if (rect.width > 0) {
          var center = rect.left + rect.width / 2;
          var half = Math.min(210, (window.innerWidth - 32) / 2);
          center = Math.max(16 + half, Math.min(window.innerWidth - 16 - half, center));
          panel.style.left = center + 'px';
          return;
        }
      }
      panel.style.left = '50%';
    }

    function foilsFor(it) {
      var btn = selectedOptionBtn(it);
      var allowed = (btn && btn.dataset.foils ? btn.dataset.foils : '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      var list = foilsAll;
      if (allowed.length) {
        list = foilsAll.filter(function (f) { return allowed.indexOf(f.title.toLowerCase()) > -1; });
        if (!list.length) list = foilsAll;
      }
      return list;
    }

    function foilValue(f) {
      return (f.colour && f.colour !== '') ? f.title.toLowerCase() : 'blind';
    }

    function foilLabel(f) {
      return f.title.replace(/\s*\(no colour\)\s*/i, '').trim() || f.title;
    }

    function renderFoils(it) {
      if (!it.monoRefs) return;
      var listEl = it.monoRefs.foilList;
      var swatch = it.monoRefs.swatch;
      var label = it.monoRefs.foilLabelEl;
      var list = foilsFor(it);

      if (!it.monoFoil || !list.some(function (f) { return foilValue(f) === it.monoFoil.value; })) {
        var first = list[0];
        it.monoFoil = { title: first.title, value: foilValue(first), colour: first.colour || '' };
      }
      swatch.style.backgroundColor = it.monoFoil.colour || 'transparent';
      label.textContent = foilLabel(it.monoFoil);

      listEl.innerHTML = '';
      list.forEach(function (f) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bundle-item__mono-colour-option';
        var sw = document.createElement('span');
        sw.className = 'bundle-item__mono-swatch';
        sw.style.backgroundColor = f.colour || 'transparent';
        var nm = document.createElement('span');
        nm.textContent = f.title;
        b.appendChild(sw); b.appendChild(nm);
        b.addEventListener('click', function (e) {
          e.stopPropagation();
          it.monoFoil = { title: f.title, value: foilValue(f), colour: f.colour || '' };
          swatch.style.backgroundColor = f.colour || 'transparent';
          label.textContent = foilLabel(f);
          softHide(listEl, true);
        });
        listEl.appendChild(b);
      });
    }

    function updateMonoLimits(it) {
      if (!it.monoRefs) return;
      var btn = selectedOptionBtn(it);
      var limit = parseInt((btn && btn.dataset.letterLimit) || '3', 10) || 3;
      var input = it.monoRefs.input;
      input.maxLength = limit;
      input.placeholder = 'Add Up to ' + limit + ' Letters';
      if (input.value.length > limit) input.value = input.value.substring(0, limit);
      renderFoils(it);
    }

    // Mirrors the panel selection onto the theme's own variant inputs.
    // Deferred on first run: firing change events while the theme's product
    // section is still initialising aborts the rest of its setup.
    function syncTheme() {
      try {
        var v = currentVariant();
        var swatches = Array.prototype.slice.call(document.querySelectorAll('.product-single [data-single-option-selector]'));
        if (swatches.length) {
          var groups = {}; var order = [];
          swatches.forEach(function (inp) {
            var key = inp.dataset.index || inp.getAttribute('name') || 'x';
            if (!groups[key]) { groups[key] = []; order.push(key); }
            groups[key].push(inp);
          });
          order.forEach(function (key, i) {
            var it = items[i];
            if (!it) return;
            var match = null;
            groups[key].forEach(function (inp) { if (inp.value === it.value) match = inp; });
            if (match && !match.checked) {
              match.checked = true;
              match.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        } else if (v) {
          var sel = document.querySelector('.product-single select[name="id"], .product-single input[name="id"]');
          if (sel) {
            sel.value = v.id;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      } catch (e) { /* non-fatal */ }
    }

    function recompute() {
      var v = currentVariant();
      var standaloneSum = componentTotal();

      items.forEach(function (it) {
        var btn = selectedOptionBtn(it);
        var standalone = parseInt((btn && btn.dataset.price) || '0', 10);
        var priceEl = it.el.querySelector('[data-item-price]');
        var compareEl = it.el.querySelector('[data-item-compare]');
        var allocated = standalone;
        if (v && standaloneSum > 0 && v.price < standaloneSum) {
          allocated = Math.round(v.price * (standalone / standaloneSum));
        }
        priceEl.textContent = money(allocated);
        if (allocated < standalone - 49) {
          compareEl.textContent = money(standalone);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      });

      var monoTotal = committedMonoCount(null) * (config.monoPrice || 0);
      var compareBase = compareFor(v);

      if (!v || !v.available) {
        atcBtn.disabled = true;
        atcCompare.hidden = true;
        atcPrice.textContent = v ? 'Sold Out' : 'Unavailable';
      } else {
        atcBtn.disabled = false;
        var total = v.price + monoTotal;
        var compare = compareBase > 0 ? compareBase + monoTotal : 0;
        atcPrice.textContent = money(total);
        if (compare > total + 49) {
          atcCompare.textContent = money(compare);
          atcCompare.hidden = false;
        } else {
          atcCompare.hidden = true;
        }
      }

      updatePdpPrice(v, compareBase);
      updateMonoTotals();
    }

    function resetMonos() {
      items.forEach(function (it) {
        it.mono = null;
        if (it.monoRefs) {
          it.monoRefs.input.value = '';
          it.monoRefs.applyBtn.disabled = true;
        }
        var mono = it.el.querySelector('[data-mono]');
        if (mono) {
          mono.dataset.applied = 'false';
          var summary = mono.querySelector('[data-mono-summary]');
          if (summary) summary.textContent = 'Monogramming';
        }
      });
    }

    function doAddToCart(triggerBtn) {
      var v = currentVariant();
      if (!v || !v.available) return;
      errorsEl.innerHTML = '';

      var monoItems = items.filter(function (it) { return it.mono && it.mono.letters; });
      var stamp = String(Date.now());
      var compareAt = parseInt(v.compareAtPrice || 0, 10);
      var componentSum = componentTotal();
      var lineItems = [];

      var fontName = (fonts[0] && fonts[0].title ? fonts[0].title : 'Serif').toLowerCase();
      var sizeName = (sizes[0] && sizes[0].title ? sizes[0].title : '36pt').toLowerCase();

      // One Personalisation Charge line per monogrammed component.
      //
      // The monogram details are written onto EACH charge line, not only onto
      // the bundle parent. Shopify Bundles expands the parent into its component
      // lines at checkout and does not copy line item properties down to them,
      // and the REST Orders API only returns the component lines — so properties
      // held on the parent alone never reach the warehouse integration
      // (see order #200982). The charge line is a standalone line that survives
      // expansion and is delivered by every order API, so the fulfilment side
      // reads the monogram from here and matches it to the component via SKU.
      monoItems.forEach(function (it) {
        var chargeProps = {
          'Personalisation': 'Monogram',
          'Letters': it.mono.letters,
          'Colour': it.mono.foilValue,
          'Font': fontName,
          'Size': sizeName,
          '_bundle_group': stamp
        };
        var sku = skuFor(it);
        if (sku) chargeProps['SKU'] = sku;
        if (it.title) chargeProps['Component'] = it.title;

        lineItems.push({
          id: config.monoVariantId,
          quantity: 1,
          properties: chargeProps
        });
      });

      var parentProps = {};

      if (monoItems.length) {
        var multiple = monoItems.length > 1;

        var skus = monoItems.map(function (it) {
          var sku = skuFor(it);
          if (!sku) return '';
          return multiple ? sku + ' (' + it.title + ')' : sku;
        }).filter(Boolean).join(', ');

        var letters = monoItems.map(function (it) {
          return multiple ? it.mono.letters + ' (' + it.title + ')' : it.mono.letters;
        }).join(', ');

        var colours = monoItems.map(function (it) {
          return multiple ? it.mono.foilValue + ' (' + it.title + ')' : it.mono.foilValue;
        }).join(', ');

        if (skus) parentProps['SKU'] = skus;
        parentProps['Personalisation'] = 'Monogram';
        parentProps['Letters'] = letters;
        parentProps['Colour'] = colours;
        parentProps['Font'] = fontName;
        parentProps['Size'] = sizeName;
        parentProps['_bundle_group'] = stamp;
      }

      // Drives the cart strikethrough. Not needed when compare_at_price is set,
      // because the theme renders the sale price natively in that case.
      if (compareAt <= v.price && componentSum > v.price) {
        parentProps['_bundle_compare'] = componentSum;
      }

      if (Object.keys(parentProps).length) {
        lineItems.push({ id: v.id, quantity: 1, properties: parentProps });
      } else {
        lineItems.push({ id: v.id, quantity: 1 });
      }

      if (window.cart) window.cart.button = triggerBtn || atcBtn;
      atcBtn.disabled = true;

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: lineItems })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          atcBtn.disabled = false;
          if (res.status) {
            errorsEl.innerHTML = '<div class="errors" data-error>' + res.message + ': ' + res.description + '</div>';
            return;
          }
          resetMonos();
          recompute();
          if (window.cart && window.cart.cartDrawerEnabled) {
            window.cart.getCart();
          } else {
            window.location = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
          }
        })
        .catch(function () {
          atcBtn.disabled = false;
          errorsEl.innerHTML = '<div class="errors" data-error>Something went wrong. Please try again.</div>';
        });
    }

    items.forEach(function (it) {
      var toggle = it.el.querySelector('[data-colour-toggle]');
      var list = it.el.querySelector('[data-colour-list]');
      var label = it.el.querySelector('[data-colour-label]');
      var thumb = it.el.querySelector('[data-bundle-thumb]');

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var willOpen = !isShown(list);
        closeAllDropdowns();
        if (willOpen) {
          softShow(list);
          toggle.setAttribute('aria-expanded', 'true');
          softShow(backdrop);
        }
      });

      it.el.querySelectorAll('[data-colour-option]').forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          e.stopPropagation();
          if (opt.dataset.available !== 'true') return;
          it.value = opt.dataset.value;
          label.textContent = it.value;
          if (opt.dataset.image) thumb.src = opt.dataset.image;
          it.el.querySelectorAll('[data-colour-option]').forEach(function (o) { o.classList.remove('is-selected'); });
          opt.classList.add('is-selected');
          closeAllDropdowns();
          updateMonoLimits(it);
          recompute();
          syncTheme();
        });
      });

      var mono = it.el.querySelector('[data-mono]');
      if (mono) {
        var monoToggle = mono.querySelector('[data-mono-toggle]');
        var panel = mono.querySelector('[data-mono-panel]');
        var input = panel.querySelector('[data-mono-letters]');
        var applyBtn = panel.querySelector('[data-mono-apply]');
        var foilToggle = panel.querySelector('[data-mono-colour-toggle]');
        var foilList = panel.querySelector('[data-mono-colour-list]');

        it.monoRefs = {
          panel: panel,
          input: input,
          applyBtn: applyBtn,
          totalEl: panel.querySelector('[data-mono-atc-total]'),
          foilList: foilList,
          swatch: panel.querySelector('[data-mono-swatch]'),
          foilLabelEl: panel.querySelector('[data-mono-colour-label]')
        };

        panel.hidden = true;
        document.body.appendChild(panel);
        monoPanels.push({ panel: panel, toggle: monoToggle });

        panel.addEventListener('click', function (e) { e.stopPropagation(); });

        renderFoils(it);

        monoToggle.addEventListener('click', function (e) {
          e.stopPropagation();
          var willOpen = !isShown(panel);
          closeAllDropdowns();
          if (willOpen) {
            updateMonoTotals();
            positionMonoPanel(panel);
            softShow(panel);
            monoToggle.setAttribute('aria-expanded', 'true');
            softShow(backdrop);
            input.focus();
          }
        });

        window.addEventListener('resize', function () {
          if (isShown(panel)) positionMonoPanel(panel);
        });

        input.addEventListener('input', function () {
          var max = input.maxLength > 0 ? input.maxLength : 3;
          input.value = input.value.toUpperCase().replace(/[^A-Z0-9,.]/g, '').substring(0, max);
          applyBtn.disabled = input.value.length === 0;
        });

        foilToggle.addEventListener('click', function (e) {
          e.stopPropagation();
          if (isShown(foilList)) { softHide(foilList, true); } else { softShow(foilList); }
        });

        applyBtn.addEventListener('click', function () {
          if (!input.value) return;
          it.mono = {
            letters: input.value,
            foilValue: it.monoFoil.value,
            foilTitle: it.monoFoil.title
          };
          closeAllDropdowns();
          doAddToCart(applyBtn);
        });
      }
    });

    document.addEventListener('click', function () { closeAllDropdowns(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllDropdowns();
    });

    atcBtn.addEventListener('click', function () { doAddToCart(atcBtn); });

    // Render our own UI immediately — this touches nothing the theme owns.
    recompute();

    // Hand off to the theme's variant inputs only once its section init has
    // finished, so the two cannot collide.
    function firstSync() {
      setTimeout(function () {
        syncTheme();
        recompute();
      }, 0);
    }

    if (document.readyState === 'complete') {
      firstSync();
    } else {
      window.addEventListener('load', firstSync);
    }
  }

  function dedupeRoots(roots) {
    var firstVisible = null;
    roots.forEach(function (r) {
      var rect = r.getBoundingClientRect();
      var visible = rect.width > 0 && rect.height > 0;
      if (visible) {
        if (firstVisible) {
          r.style.display = 'none';
        } else {
          firstVisible = r;
        }
      }
    });
  }

  function init() {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-bundle-items]'));
    var configs = document.querySelectorAll('[data-bundle-config]');
    dedupeRoots(roots);
    roots.forEach(function (root, i) {
      initOne(root, configs[i] || configs[0]);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
